export class MutationTypes {
  public static readonly SET_LOGIN_REDIRECT = 'SET_LOGIN_REDIRECT'
  public static readonly SET_ROUTE_MAP = 'SET_ROUTE_MAP'
  public static readonly SET_RECIPE_LIST = 'SET_RECIPE_LIST'
  public static readonly SET_PAGINATION = 'SET_PAGINATION'
  public static readonly SET_RECIPE_LIST_PARAMS = 'SET_RECIPE_LIST_PARAMS'
  public static readonly SET_AUTHOR_RECIPE_LIST_PARAMS =
    'SET_AUTHOR_RECIPE_LIST_PARAMS'
  public static readonly REQUEST_TOKEN = 'REQUEST_TOKEN'
  public static readonly SET_TOKEN = 'SET_TOKEN'
  public static readonly REQUEST_TOKEN_ERROR = 'REQUEST_TOKEN_ERROR'
  public static readonly CLEAR_TOKEN = 'CLEAR_TOKEN'
  public static readonly SET_LOGIN_STATUS = 'SET_LOGIN_STATUS'
  public static readonly SET_AVATAR = 'SET_AVATAR'
  public static readonly REQUEST_USER = 'REQUEST_USER'
  public static readonly SET_USER = 'SET_USER'
  public static readonly REQUEST_USER_ERROR = 'REQUEST_USER_ERROR'
  public static readonly CLEAR_USER = 'CLEAR_USER'
  public static readonly SET_AUTHOR = 'SET_AUTHOR'
  public static readonly SET_RECIPE_DETAIL = 'SET_RECIPE_DETAIL'
  public static readonly SET_RECIPE_PUBLISH_STATUS = 'SET_RECIPE_PUBLISH_STATUS'
  public static readonly SET_RECIPE_COVER = 'SET_RECIPE_COVER'
  public static readonly SET_PREVIOUS = 'SET_PREVIOUS'
  public static readonly SET_ALERT = 'SET_ALERT'
  public static readonly RESET_ALERT = 'RESET_ALERT'
  public static readonly SET_DIALOG = 'SET_DIALOG'
  public static readonly CLEAR_DIALOG = 'CLEAR_DIALOG'
}
